import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { GlobalStyles } from '../common/globalstyles';
import { QrPage } from '../common/qrcode/index';
import { QrInstant } from '../common/qrcode/instant';
import { TestPage } from '../common/test/testPage';
import '../public/style.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

export const App = () => {
  return (
    <>
      <GlobalStyles />
      <BrowserRouter>
        <Switch>
          <Route exact path="/test" component={TestPage} />
          <Route exact path="/instant" component={QrInstant} />
          <Route path="/:id?" component={QrPage} />
        </Switch>
      </BrowserRouter>
    </>
  );
};
